import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import './App.css';
import CartBar from './components/cart/CartBar';
import Navbar from './components/header/Navbar';
import Home from './components/pages/home/Home';
import Book from './components/pages/Book';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Resources from './components/pages/Resources/Resources';
import Footer from './components/widgets/Footer';
import NavbarState from './context/navbar/NavbarState';



const App = () => {
  return (
    <Router>
      <div className="App">
        <CartBar />
        <NavbarState>
          <Navbar />
        </NavbarState>
        <div>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/book' component={Book} />
            <Route exact path='/about' component={About}/>
            <Route exact path='/contact' component={Contact} />
            <Route exact path='/resources' component={Resources} />
          </Switch>
          <Footer />
        </div>
      </div>
    </Router>
    
  )
}


export default App;
